import { Props } from 'shared/@types';
import { MarkdownPage } from 'shared/components/markdown-page';
import { useTranslation } from 'react-i18next';

const TermsOfUseScreen = ({ isInModal = false }: Props<{ isInModal?: boolean }>) => {
  const { t } = useTranslation('documents');

  return <MarkdownPage markdown={t('terms_of_use')} variant={isInModal ? 'modal' : 'page'} />;
};

export { TermsOfUseScreen };
